import { render, staticRenderFns } from "./FSectorTypeTable.vue?vue&type=template&id=27e26833&scoped=true"
import script from "./FSectorTypeTable.vue?vue&type=script&lang=js"
export * from "./FSectorTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e26833",
  null
  
)

export default component.exports